import { z } from 'zod';
/**
 * The languages a room can be opened in. The spec's acceptance set is RU <-> ES;
 * everything past that is a product decision rather than a code change, because
 * the translator adapter passes the code straight through to the provider and
 * does not care which one it is.
 *
 * What is NOT free about widening the list: the provider has to support the
 * language, and a right-to-left one changes how the page is laid out. Both are
 * handled below rather than assumed.
 */
export const LANGUAGES = ['ru', 'es', 'en', 'nl', 'de', 'fr', 'ca', 'he'];
export const languageSchema = z.enum(LANGUAGES);
/**
 * Each language named in itself. Someone picking their own language out of a
 * list reads for the word they already know — translating these into the
 * interface language would hide it behind a word they might not.
 */
export const LANGUAGE_LABELS = {
    ru: 'Русский',
    es: 'Español',
    en: 'English',
    nl: 'Nederlands',
    de: 'Deutsch',
    fr: 'Français',
    ca: 'Català',
    he: 'עברית',
};
/** BCP-47 tags for speech UI hints and `lang` attributes. */
export const LANGUAGE_TAGS = {
    ru: 'ru-RU',
    es: 'es-ES',
    en: 'en-US',
    nl: 'nl-NL',
    de: 'de-DE',
    fr: 'fr-FR',
    ca: 'ca-ES',
    he: 'he-IL',
};
/**
 * Written right to left. A short list on purpose: it is the set this app
 * offers, not a general table, and a wrong entry here mirrors a whole page.
 */
const RTL = new Set(['he']);
/**
 * Which way a language runs. Subtitles need this per pane — a Hebrew speaker's
 * words are right-to-left even when the surrounding interface is not — and the
 * document needs it for whichever language the interface is in.
 */
export const directionOf = (language) => (RTL.has(language) ? 'rtl' : 'ltr');
//# sourceMappingURL=languages.js.map